import React from 'react'
import {
  Card,
  Typography,
  Avatar,
  IconButton,
  Tooltip,
  useTheme,
  Box,
  Divider,
  Badge,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as OpenIcon } from '../../assets/icons/OpenIcon.svg'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    // margin: theme.spacing(1, 0),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    flexWrap: 'no-wrap',
    gap: theme.spacing(1),
  },
  avatarContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    // flexWrap: 'wrap',
  },
  avatar: {
    width: 50,
    height: 50,
    // border: "2px solid #f39c12", // Orange border
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  button: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '16px',
    fontSize: '12px',
    color: '#FFFFFF',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  iconButton: {
    color: theme.palette.primary.main,
  },
  label: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: Colors.TEXT_COLOR_TERTIARY,
  },
  value: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  iconCircle: {
    width: 16,
    height: 16,
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    border: '2px solid #AFAFAF',
  },
  name: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  labTestText: {
    color: Colors.LAB_CARD_COLOR_TEST_SUCCESS,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  labReportText: {
    color: Colors.LAB_CARD_COLOR_REPORT_AWAIT,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: 'orange',
      color: 'green',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },
  },
})

const LabDetailsCard = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  // eslint-disable-next-line
  const onViewClick = (customerDetails: any) => {
    navigate(`${process.env.PUBLIC_URL}/customerDetails`)
  }

  return (
    <Card className={classes?.card} elevation={0}>
      <div className={classes?.avatarContainer}>
        <Badge
          overlap='circular'
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          variant='dot'
          className={classes?.badge}
        >
          <Avatar
            className={classes?.avatar}
            alt='Anya'
            src={`https://i.pravatar.cc/150?img=${Math.random()}`}
          />
        </Badge>
        <Box className={classes?.textContent}>
          <Tooltip
            title={'Veera Venkata Vinay Avaru Veera ahjsjsjsj'}
            placement='right'
          >
            <Typography
              className={classes?.name}
              width={'250px'}
              noWrap
              textOverflow={'ellipsis'}
              overflow={'hidden'}
            >
              Veera Venkata Vinay Avaru Veera ahjsjsjsj
            </Typography>
          </Tooltip>
          <Typography className={classes?.name}>799983737</Typography>
        </Box>
      </div>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.details} minWidth={'130px'}>
        <Typography className={classes?.label}>
          MRN NO - <span className={classes?.value}>8989897</span>
        </Typography>
        <Typography className={classes?.label}>
          ABA ID - <span className={classes?.value}>638638</span>
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.info} minWidth={'100px'}>
        <Typography className={classes?.label}>No. of People</Typography>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          gap={1}
        >
          <Typography className={classes?.value}>4</Typography>
          <Tooltip title='More information'>
            <InfoOutlinedIcon
              color='primary'
              fontSize='small'
              className={classes?.iconButton}
            />
          </Tooltip>
        </Box>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.info} minWidth={'150px'}>
        <Typography className={classes?.label}>Lab Test</Typography>
        <Typography className={classes?.labTestText}>
          Sample Collected
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.info} minWidth={'200px'}>
        <Typography className={classes?.label}>Report Status</Typography>
        <Typography className={classes?.labReportText}>
          Sample Awaiting Processing
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem />
      <Box className={classes?.info} minWidth={'100px'}>
        <Typography className={classes?.label}>Date</Typography>
        <Typography className={classes?.value}>12/12/2024</Typography>
      </Box>

      <div className={classes?.actions}>
        <IconButton color='primary' onClick={onViewClick}>
          <OpenIcon />
        </IconButton>
      </div>
    </Card>
  )
}

export default LabDetailsCard
